import { Box } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { ArrowDropUpIcon, ArrowDropDownIcon } from 'components/uiIcons';

const SortableHeader = ({ field, label, sortBy, onSortChange, textAlign = 'center' }) => {
  const ascValue = `${field}_asc`;
  const descValue = `${field}_desc`;
  const isAsc = sortBy === ascValue;
  const isDesc = sortBy === descValue;
  const isActive = isAsc || isDesc;

  const handleClick = () => {
    if (isAsc) {
      onSortChange(descValue);
    } else {
      onSortChange(ascValue);
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: textAlign === 'left' ? 'flex-start' : 'center',
        userSelect: 'none',
        fontWeight: isActive ? 'bold' : 'normal',
        '&:hover': { opacity: 0.7 },
      }}
    >
      <FormattedMessage id={label} />
      {isActive && (
        isDesc ? (
          <ArrowDropDownIcon />
        ) : (
          <ArrowDropUpIcon />
        )
      )}
    </Box>
  );
};

export default SortableHeader;
